module.exports = __webpack_public_path__ + "a235d21966e7f27480d23456d04e0087.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/checkout/en/valu.png
// module id = ./app/images/checkout/en/valu.png
// module chunks = 40